"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePayStatusOwnerRelationIndex = void 0;
const enums_1 = require("../enums");
const validatePayStatusOwnerRelationIndex = (ownerRelationIndex) => {
    const ownerTypes = Object.values(enums_1.PayStatusOwnerType).join('|');
    const periods = Object.values(enums_1.PayStatusPeriod).join('|');
    const indexRegexString = `^\\{([^}]+)\\}-\\{(${ownerTypes})\\}-\\{(${periods})\\}$`;
    const indexRegex = new RegExp(indexRegexString);
    if (!indexRegex.test(ownerRelationIndex)) {
        throw new Error('Invalid owner relation index');
    }
    const match = ownerRelationIndex.match(indexRegex);
    if (!match) {
        throw new Error('Invalid owner relation index');
    }
    const [, ownerId, ownerType, period] = match;
    return {
        ownerId,
        ownerType: ownerType,
        period: period,
    };
};
exports.validatePayStatusOwnerRelationIndex = validatePayStatusOwnerRelationIndex;
